// In order to keep core.module.ts as small as possible, router functionality is kept in this file.
// This is not done with other modules because it is conventient to have 'ng generate component' automatically add a component to
// the appropriate module by running it in that directory.

import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './security/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { Error404Component } from './pages/error404/error404.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { EditUserComponent } from '../administration/users/edit-user/edit-user.component';
import { EditUserModule } from '../administration/users/edit-user/edit-user.module';
import { HelpFilesComponent } from '../help/help-files.component';
import { HelpVideosComponent } from '../help/help-videos/help-videos.component';
import { WebReleaseNotesComponent } from './pages/web-release-notes/web-release-notes.component';

// This is the root of our navigation menu route definitions
const routes: Routes = [
	{ 
		path: ''
		, component: HomeComponent
		, pathMatch: 'full' 
	}
	, { 
		path: 'dashboard'
		, component: DashboardComponent
		, canActivate: [ AuthGuard] 
	}
	, { 
		path: 'login'
		, component: LoginComponent 
	}
	, { 
		path: 'web-release-notes'
		, component: WebReleaseNotesComponent
		, canActivate: [ AuthGuard] 
	}
	, { 
		path: 'edit-user/:id'
		, component: EditUserComponent
		, canActivate: [ AuthGuard ] 
	}
	, { 
		path: 'forgot-password'
		, component: ForgotPasswordComponent 
	}
	, { 
		path: 'change-password/:id'
		, component: ChangePasswordComponent 
	}
	, { 
		path: 'administration'
		, canLoad: [AuthGuard]
		, loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule) 
	}
	, { 
		path: 'reports'
		, canLoad: [AuthGuard]
		, loadChildren: () => import('../reports/reports.module').then(m => m.ReportsModule) 
	}
	, { 
		path: 'events'
		, canLoad: [AuthGuard]
		, loadChildren: () => import('../events/events.module').then(m => m.EventsModule) 
	}
	, { 
		path: 'help'
		, canActivate: [AuthGuard]
		, component: HelpFilesComponent
	}
	, { 
		path: 'help/help-video/:id'
		, canActivate: [AuthGuard]
		, component: HelpVideosComponent
	}
	, { 
		path: '**'
		, redirectTo: '' 
	}
];

export class CoreRouting {
	static declarations = [
		HomeComponent
		, DashboardComponent
		, LoginComponent
		, Error404Component
		, ForgotPasswordComponent
		, ChangePasswordComponent
		, HelpFilesComponent
		, HelpVideosComponent
	];
	static imports = [
		RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', preloadingStrategy: QuicklinkStrategy })
		, EditUserModule
	];
	static exports = [ RouterModule ];
	static providers = [ AuthGuard ];
}
